import { type FCC } from "@forento/ui/types/react"

import BrandContext, { brands } from "."

const BrandProvider: FCC = ({ children }) => {
	return <BrandContext.Provider value={brands.forento}>{children}</BrandContext.Provider>
}

export default BrandProvider
